import { get } from "./utils";

export const statistic = {
  listMessageType: (token) => {
    return get("/api/basis/statistic/message/type/", {}, token);
  },
  listMessageDepartment: (token) => {
    return get("/api/basis/statistic/message/department/", {}, token);
  },
  listMessageMonth: (token) => {
    return get("/api/basis/statistic/message/month/", {}, token);
  },
  listMessageAdministrative: (token) => {
    return get("/api/basis/statistic/message/administrative/", {}, token);
  },
  listMessageTotalDepartment: (parameters, token) => {
    return get(
      "/api/basis/statistic/message/total_department/",
      parameters,
      token
    );
  },
  listAnnouncementType: (token) => {
    return get("/api/basis/statistic/announcement/type/", {}, token);
  },
  listAnnouncementMonth: (token) => {
    return get("/api/basis/statistic/announcement/month/", {}, token);
  },
};
